import { ReactNode } from 'react'
import { Link01Icon, LinkBroken02Icon } from '@systemeio/icons'
import { useSlate } from 'slate-react'
import { twMerge } from 'tailwind-merge'
import { ToolbarButton } from 'modules/comments/components/comment-editor/common/toolbar-button'
import { isBlockActive } from 'modules/community/utils/editor/core'
import { unwrapLink } from 'modules/community/utils/editor/link'

const LinkButton = ({
  setLinkIsEditing,
}: {
  setLinkIsEditing: (value: boolean) => void
}): ReactNode => {
  const editor = useSlate()
  const linkActive = isBlockActive(editor, 'link')

  const handleClick = (): void => {
    if (linkActive) {
      unwrapLink(editor)
    } else {
      setLinkIsEditing(true)
    }
  }

  return (
    <ToolbarButton
      format={linkActive ? 'unlink' : 'link'}
      active={linkActive}
      onClick={handleClick}
    >
      {linkActive ? (
        <LinkBroken02Icon
          className={twMerge(
            `size-5 text-text-secondary md:size-6`,
            linkActive && 'text-[initial]',
          )}
        />
      ) : (
        <Link01Icon
          className={twMerge(
            `size-5 text-text-secondary md:size-6`,
            linkActive && 'text-[initial]',
          )}
        />
      )}
    </ToolbarButton>
  )
}

export default LinkButton
